exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header-logo-1{fill:none}.header-logo-2{fill:#f0f9f8}.header-logo-3{fill:#72cac2}.header-logo-4{fill:#fff}.header-logo-5{fill:#1f4d69}\n", ""]);
